import { getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";

import { type Snackbar, STATUS_MODULE_KEY } from "@/utils/enums";
import store from "@/vuexStore";

// @ts-expect-error decorator is picking the wrong overload as its type
@Module({
  namespaced: true,
  name: STATUS_MODULE_KEY,
  store,
  dynamic: true,
})
class StatusModule extends VuexModule {
  snackbar: Snackbar = {
    show: false,
    message: "",
    color: "success",
  };

  showBanner = false;

  @Mutation
  public setSnackbar(snackbar: Snackbar) {
    this.snackbar = snackbar;
  }

  @Mutation
  public setBanner(showBanner: boolean) {
    this.showBanner = showBanner;
  }
}

const statusModule = getModule(StatusModule);

export default statusModule;
